// extracted by mini-css-extract-plugin
export default {"chat-form":"styles_chat-form__Ap75+","chat-form__input":"styles_chat-form__input__-kNQo","chat-form__button":"styles_chat-form__button__fdHcf"};